import React, { useState } from 'react';
import { aiTools } from '../data/mockData';
import { Smile } from 'lucide-react';

const AIToolsSection = () => {
  const [activeTab, setActiveTab] = useState('automated-ads');

  const activeTool = aiTools.find((tool) => tool.id === activeTab);

  return (
    <section className="py-20 bg-[#1e293b]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white flex items-center justify-center gap-3 flex-wrap">
            Ferramentas de IA
            <span className="inline-flex items-center justify-center w-12 h-12 bg-[#3b82f6] rounded-full">
              <Smile className="h-7 w-7 text-white" />
            </span>
            que impulsionam vendas
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {aiTools.map((tool) => (
            <button
              key={tool.id}
              onClick={() => setActiveTab(tool.id)}
              className={`px-6 py-3 rounded-full text-sm font-medium transition-all ${
                activeTab === tool.id
                  ? 'bg-white text-[#1a1a2e]'
                  : 'bg-transparent text-white border border-white/30 hover:bg-white/10'
              }`}
            >
              {tool.title}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-white">{activeTool?.subtitle}</h3>
            <p className="text-lg text-gray-300">{activeTool?.description}</p>
          </div>
          <div className="relative">
            <div className="bg-gradient-to-br from-[#3b82f6]/20 to-[#60a5fa]/20 rounded-3xl p-2">
              <img
                src={activeTool?.image}
                alt={activeTool?.title}
                className="rounded-2xl w-full h-[400px] object-cover shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIToolsSection;
